import React from "react";
import Box from "@mui/material/Box";
import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from "@mui/material/CircularProgress";
import { Typography } from "@mui/material";
import { SPINNER_MESSAGE } from "constants/ocplcConstants";

const useStyles = makeStyles((theme) => ({
  publishLoading: {
    position: "fixed",
    top: "50%",
    left: "50%",
    zIndex: "99",
    transform: "translate(-50%, -50%)",
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
  },
  message:{
    marginTop: "8px",
  }
  
}));

export const ButtonSpinner = () => {
  const classes = useStyles();

  return (
    <Box className={classes.publishLoading}>
      <CircularProgress color="primary" />
      <Typography variant="body1" className={classes.message}>{SPINNER_MESSAGE}</Typography>
    </Box>
  );
}

